import { alertError } from "../../utils/feedback";
import {
  REQUEST_STARTED,
  REQUEST_SUCCEEDED,
  REQUEST_FAILED,
  LOGED_OUT,
} from "../types/feedbackTypes";

export const requestStarted = (boul) => ({
  type: REQUEST_STARTED,
  payload: boul,
});

export const requestSucceeded = () => ({
  type: REQUEST_SUCCEEDED,
});

export const loggedOut = () => ({
  type: LOGED_OUT,
});

export const requestFailed = (err) => {
  const local = localStorage.getItem("i18nextLng").slice(0, 2) || "en";

  const storedUser = localStorage.getItem("user");

  let errorMessage;

  if (local === "en") {
    errorMessage =
      err?.message || (err?.message === null ? undefined : "Request failed");
  } else if (local === "fr") {
    errorMessage =
      err?.message_fr ||
      (err?.message_fr === null ? undefined : "Request failed");
  }

  if (
    err &&
    err.response &&
    err.response.data &&
    err.response.data.error &&
    typeof err.response.data.error === "string"
  ) {
    errorMessage = err.response.data.error;
  }
  if (
    err &&
    err.response &&
    err.response.data &&
    err.response.data.error &&
    err.response.data.error.details
  ) {
    errorMessage =
      err.response.data.error.details[0] && local === "en"
        ? err.response.data.error.details[0].message
        : err.response.data.error.details[0].message_fr;
  }
  // No "token expired" arm here any more. It fired on the retryable 401 the
  // response interceptor refreshes and replays, so it told the user their session
  // had expired on a request that then succeeded. The interceptor is the only
  // thing that knows which of the two 401s this was (F-24).
  // A terminal session end is already being explained by the modal, which owns
  // the redirect too. The request that triggered it rejects as well, and every
  // action creator funnels that here - so without this guard the user gets the
  // same sentence twice, once in a dialog and once in a toast behind it.
  const sessionEnded = err?.error_ === "session ended";

  if (errorMessage && err !== "automaticLogout" && !sessionEnded) {
    alertError(errorMessage);
  }

  return {
    type: REQUEST_FAILED,
    payload: errorMessage,
  };
};
